function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { stringValue } from 'vega-util';
import { FACET_CHANNELS } from '../../channel';
import { SELECTION_ID } from '../../selection';
import { vals } from '../../util';
import { isFacetModel } from '../model';
import interval from './interval';
import multi from './multi';
import single from './single';
export var STORE = '_store';
export var TUPLE = '_tuple';
export var MODIFY = '_modify';
export var SELECTION_DOMAIN = '_selection_domain_';
export var VL_SELECTION_RESOLVE = 'vlSelectionResolve';
var compilers = {
  single: single,
  multi: multi,
  interval: interval
};
export function forEachSelection(model, cb) {
  var selections = model.component.selection;
  if (selections) {
    var _iterator = _createForOfIteratorHelper(vals(selections)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var sel = _step.value;
        var success = cb(sel, compilers[sel.type]);
        if (success === true) break;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}
function getFacetModel(model) {
  var parent = model.parent;
  while (parent) {
    if (isFacetModel(parent)) {
      break;
    }
    parent = parent.parent;
  }
  return parent;
}
export function unitName(model) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      escape: true
    },
    escape = _ref.escape;
  var name = escape ? stringValue(model.name) : model.name;
  var facetModel = getFacetModel(model);
  if (facetModel) {
    var facet = facetModel.facet;
    var _iterator2 = _createForOfIteratorHelper(FACET_CHANNELS),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var channel = _step2.value;
        if (facet[channel]) {
          name += " + '__facet_".concat(channel, "_' + (facet[").concat(stringValue(facetModel.vgField(channel)), "])");
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return name;
}
export function requiresSelectionId(model) {
  var identifier = false;
  forEachSelection(model, function (selCmpt) {
    identifier = identifier || selCmpt.project.items.some(function (proj) {
      return proj.field === SELECTION_ID;
    });
  });
  return identifier;
}